import React from "react";
import { Box } from "@mui/material";
import { DotLottleLoader } from "../Loader";

interface Props {
  visible: boolean;
}

export function DownloadOverlay({ visible }: Props) {
  if (!visible) return null;
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255,255,255,0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1500,
      }}
    >
      <DotLottleLoader fill={false} sx={{ width: 400, height: 400 }} />
    </Box>
  );
}
